import errorMessageHandler from '@/mixins/errorMessageHandler'
import { getRef } from '@/utils/getRefElement'

export default {
  mixins: [errorMessageHandler],
  methods: {
    closeModalAndDelayFetch () {
      const addonListComp = getRef(this.$refs.addonList)
      addonListComp.addonsActivationModal = false
      addonListComp.addonsDeactivateModal = false

      setTimeout(() => {
        this.fetchAddons()
      }, 300)
    },
    activateAddonsApi (externalId) {
      this.confirmationLoader = true
      const id = this.$props.resourcesData.subscriberIdentity
      const dataToSend = {
        subscriberIdentity: id,
        addonExternalId: externalId,
        activate: true
      }
      this.$apiRequest.post('user/services/addons', dataToSend)
        .then(response => {
          if (response.status === 200) {
            this.toast('success', {
              title: this.$t('toastMessages.successToastTitle'),
              message: this.$t('toastMessages.successAddonActivationMessage')
            })
          }
          this.closeModalAndDelayFetch()
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
          this.confirmationLoader = false
        })
        .finally(() => {
          getRef(this.$refs.addonList).buttonDisabled = false
          this.dataLoading = false
          this.confirmationLoader = false
        })
    },
    deactivateAddonsApi (activatedExternalId) {
      this.confirmationLoader = true
      const id = this.$props.resourcesData.subscriberIdentity
      const dataToSend = {
        subscriberIdentity: id,
        addonExternalId: activatedExternalId,
        activate: false
      }
      this.$apiRequest.post('user/services/addons', dataToSend)
        .then(response => {
          if (response.status === 200) {
            this.toast('success', {
              title: this.$t('toastMessages.successToastTitle'),
              message: this.$t('toastMessages.successAddonDeactivationMessage')
            })
          }
          this.closeModalAndDelayFetch()
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
          this.confirmationLoader = false
        })
        .finally(() => {
          getRef(this.$refs.addonList).buttonDisabled = false
          this.dataLoading = false
          this.confirmationLoader = false
        })
    }
  }
}
